import { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PaginationContexts } from '../../App'
import { clearFilter } from '../../features/filter/filterSlice'
import { fetchTags } from '../../features/tags/tagsSlice'
import Tag from './Tag'

export default function Tags() {
  const { tags } = useSelector((state) => state.tags)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchTags())
  }, [dispatch])
  const { setSelected } = useContext(PaginationContexts)
  const filterClear = () => {
    setSelected(0)
    dispatch(clearFilter())
  }
  return tags?.length > 0 ? (
    <section>
      <div className="max-w-7xl mx-auto px-5 py-6 center lg:px-0 flex space-between gap-2 border-b overflow-y-auto">
        {tags.map((tag) => (
          <Tag key={tag.id} title={tag.title} />
        ))}
        <span
          className="text-white bg-red-500 w-28 text-center rounded cursor-pointer hover:bg-red-600"
          onClick={filterClear}
        >
          Clear Filter
        </span>
      </div>
    </section>
  ) : null
}
